import { observable, makeObservable, action, computed, flow } from "mobx";

import { IChatSample } from "./types";
import * as richmodalService from "../../services/richmodal";
import { shuffleArray } from "logic/src/utils";

class chatSampleManager {
  @observable.ref list: IChatSample[];

  public constructor() {
    makeObservable(this);
    this.list = [];
    this.listMember = this.listMember.bind(this);
  }

  @computed
  get flatSampleList() {
    return this.list?.length
      ? this.list.reduce((prev, cur) => {
          prev.push(
            ...cur.query.map(ele => ({
              type: cur.type,
              icon: cur.icon,
              query: [ele],
            })),
          );
          return prev;
        }, [] as IChatSample[])
      : [];
  }

  @flow
  public *listMember() {
    const { message: list } = yield richmodalService.getChatSampleList();
    this.list = list;
  }

  @action.bound
  public flushSample = () => {
    if (this.list) {
      shuffleArray(this.list);
      this.list.forEach((item: IChatSample) => {
        shuffleArray(item.query);
      });
    }
  };
}

export default chatSampleManager;
